import { useState } from 'react';

// Remove-friends list shown inside the "Add friends" modal from the Scores
// section on Home (mirrors AddCustomLink's modal-form pattern).
//
// **Adding is commented out below.** Usernames are display names now, not
// identifiers (D39), so there is nothing to look a person up by - two players
// can share a name and the friend graph stores ObjectId refs. Connecting moves
// to the sharing/invite flow. `onAddFriend` is still accepted as a prop so the
// call sites don't need touching before that lands.
function ManageFriends({ friendsData, onAddFriend, onRemoveFriend, onChanged }) {
  const [errorMessage, setErrorMessage] = useState('');

  const onClickRemove = async (id) => {
    try {
      const removed = await onRemoveFriend(id);
      if (removed) {
        if (onChanged) onChanged();
      } else {
        setErrorMessage('Failed to remove friend. Please try again.');
      }
    } catch (error) {
      setErrorMessage('Failed to remove friend. Please try again.');
      console.log('Error in onClickRemove:', error);
    }
  };

  return (
    <div className="text-left">
      {friendsData?.friends?.length > 0 && (
        <ul className="list-none space-y-1.5 mb-4">
          {friendsData.friends.map(f => (
            <li
              key={f.id}
              className="flex justify-between items-center gap-2 py-2 px-3 rounded-lg border border-nlg-rule"
            >
              <span className="font-display font-bold text-sm text-nlg-text truncate">{f.username}</span>
              <button
                onClick={() => onClickRemove(f.id)}
                className="w-7 h-7 flex items-center justify-center bg-nlg-gold text-black rounded-full transition-transform duration-150 hover:scale-105 flex-shrink-0"
                title="Remove friend"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </li>
          ))}
        </ul>
      )}

      {/* Add-by-username, retired with D39 — usernames no longer identify
          anyone, so there's nothing to search. Replaced by the sharing/invite
          flow. Kept commented rather than deleted as a reference for the
          markup while that's built; delete it once invites ship.

      <form onSubmit={onSubmitAdd} className="flex items-center gap-2">
        <input
          type="text"
          placeholder="Enter username to follow"
          value={newFriendName}
          onChange={(e) => { setNewFriendName(e.target.value); setErrorMessage(''); }}
          className="flex-1 px-3 py-2 rounded-lg bg-white/5 border border-nlg-rule text-nlg-text placeholder:text-nlg-muted focus:outline-none focus:border-nlg-gold/50"
        />
        <button
          type="submit"
          className="w-9 h-9 flex items-center justify-center bg-nlg-gold text-nlg-bg rounded-full transition-transform duration-150 hover:scale-105 flex-shrink-0"
          title="Add friend"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24" style={{ transform: 'rotate(45deg)' }}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </form>
      */}
      {errorMessage && <p className="text-nlg-coral text-sm mt-2">{errorMessage}</p>}
    </div>
  );
}

export default ManageFriends;
